export default {
    breadcrumbs: {
        network: 'My Network',
    },
    titles: {
        my_connections: 'My Network',
    },
    message_box: {
        physicians: "You don't have providers in your network yet!",
        service_providers: "You don't have ancillary providers in your network yet!",
        invite_partners: 'Invite your favorite partners now!',
        no_pending_connections:
            'You have no pending connections. Start inviting other providers to begin enjoying the benefits of the MedMatch Network platform',
    },
    buttons: {
        invite_provider: 'invite provider',
        invite_physician: 'invite provider',
        start_now: 'Connect',
        invite_new_member: 'Invite a new member',
        send_network_message: 'network message',
        refer: 'Refer',
    },
    filters: {
        title: 'Show connections with status',
        pending_confirmation: 'Pending confirmation',
        in_my_network: 'In my Network',
    },
    tabs: {
        physicians: 'Providers',
        providers: 'Ancillary Providers',
    },
    search_network: 'Search and Add members to your network',
    network_profile_detail: {
        verify: 'Verified',
        board: 'Board Cert',
        connection: 'connections • in my network',
    },
}
